<section class="main h-100vh position-relative">
	<div class="search-title">
		<h1>Search<span *ngIf="creatorDisplayName"> / {{ creatorDisplayName }}</span></h1>
		
	</div>
	<div class="search">
		<div class="keyboard-box" dpadZone="'search'">
			<div class="main-container">
				<div class="keyboard">
					<input class="form-control mb-2" (change)="onSearchChange()" disabled [(ngModel)]="searchTerm">
					<button dpadSelectable *ngFor="let key of keyboard; let i = index" (click)="button(key)" class="key"
						[class.dpad-start]="lastKeyboardFocus === i" (focus)="lastKeyboardFocus = i">
						{{key}}
					</button>
					<button dpadSelectable (click)="button(' ')" class="key key-half spacebar mr-3"
						(focus)="lastKeyboardFocus = 136" [class.dpad-start]="lastKeyboardFocus === 136">
						<img height="20" width="70">
					</button>
					<button dpadSelectable (click)="delete()" class="key key-half ml-3"
						(focus)="lastKeyboardFocus = 137" [class.dpad-start]="lastKeyboardFocus === 137">
						<img src="../../../assets/delete-button.svg" height="35" width="50">
					</button>
				</div>
			</div>
		</div>

		<div class="search-results" [class.shift-up]="media && media.length > 0" dpadZone="'search-media'"
			dpadScrollableVertical [scrollTopPaddingPx]="100">
			<div class="ml-4" *ngIf="message">
				{{message}}
			</div>
			<div class="row ml-4 mr-4 mb-3">
				<div class="col-12 col-sm-4 col-md-4 col-xxl-4 p-1 m-0 thumb-margin"
					*ngFor='let m of media; let i = index'>
					<video-thumb-search [media]="m" (focused)="focusedMedia = i"
						[dstart]="focusedMedia === i"></video-thumb-search>
				</div>
			</div>
		</div>

	</div>
</section>
